import { render, staticRenderFns } from "./PasoDosComponent.vue?vue&type=template&id=2daad898"
import script from "./PasoDosComponent.vue?vue&type=script&lang=js"
export * from "./PasoDosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports